import RedemptionPanel from './redemptionPanel.container';

export default RedemptionPanel